var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c("vue-loading", {
        attrs: {
          active: _vm.loading,
          "is-full-page": true,
          loader: "dots",
          color: "#70A1F0"
        },
        on: {
          "update:active": function($event) {
            _vm.loading = $event
          }
        }
      })
    : _c("div", { staticClass: "box", attrs: { id: "deployments" } }, [
        _c(
          "div",
          { staticClass: "col-6" },
          [
            _c("MetricGraph", {
              attrs: {
                metrics: _vm.metrics,
                graphProperties: _vm.graphProperties
              },
              on: { updateMetric: _vm.updateMetric }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-6" },
          [
            _c("MetricData", {
              attrs: {
                graphProperties: _vm.graphProperties,
                metric: _vm.metric
              }
            })
          ],
          1
        )
      ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bdb1fc02", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdb1fc02","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Deployment.vue
// module id = null
// module chunks = 